/**
 * AutoDrive Theme — Collection Filters JS
 *
 * - Intercepts filter form changes → fetches filtered collection URL
 * - Swaps .collection-grid__inner innerHTML without full page reload
 * - Updates browser URL (pushState) so filtered URLs are shareable
 * - Manages active filter pills
 * - Handles sort dropdown changes
 */

(function () {
  'use strict';

  var CollectionFilters = {
    filterForm:   null,
    sortSelect:   null,
    gridInner:    null,
    activeFiltersEl: null,
    _debounceTimer: null,

    init: function () {
      this.filterForm      = document.querySelector('[data-filter-form]');
      this.sortSelect      = document.querySelector('[data-sort-select]');
      this.gridInner       = document.querySelector('[data-collection-grid]');
      this.activeFiltersEl = document.querySelector('[data-active-filters]');

      if (!this.filterForm && !this.sortSelect) return;

      this._bindFilterForm();
      this._bindSortSelect();
      this._bindClearAll();
      this._bindActivePillRemove();
      this._bindPopState();
    },

    /* ------------------------------------------------------------------
       Filter form — debounce checkbox changes
       ------------------------------------------------------------------ */
    _bindFilterForm: function () {
      var self = this;
      if (!this.filterForm) return;

      this.filterForm.addEventListener('change', function () {
        clearTimeout(self._debounceTimer);
        self._debounceTimer = setTimeout(function () {
          self._applyFilters();
        }, 300);
      });

      // Prevent default submit (we handle via fetch)
      this.filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        self._applyFilters();
      });
    },

    /* ------------------------------------------------------------------
       Sort dropdown
       ------------------------------------------------------------------ */
    _bindSortSelect: function () {
      var self = this;
      if (!this.sortSelect) return;

      this.sortSelect.addEventListener('change', function () {
        self._applyFilters();
      });
    },

    /* ------------------------------------------------------------------
       Clear all filters button
       ------------------------------------------------------------------ */
    _bindClearAll: function () {
      var self = this;
      var clearBtn = document.querySelector('[data-clear-filters]');
      if (!clearBtn) return;

      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // Uncheck all checkboxes
        if (self.filterForm) {
          Array.from(self.filterForm.querySelectorAll('input[type="checkbox"]')).forEach(function (cb) {
            cb.checked = false;
          });
          // Reset price inputs
          Array.from(self.filterForm.querySelectorAll('input[type="number"], input[data-price-input]')).forEach(function (el) {
            el.value = '';
          });
        }
        self._applyFilters();
      });
    },

    /* ------------------------------------------------------------------
       Active filter pills — remove on click
       ------------------------------------------------------------------ */
    _bindActivePillRemove: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-remove-filter]');
        if (!removeBtn) return;

        var paramName  = removeBtn.dataset.removeFilter;
        var paramValue = removeBtn.dataset.removeValue;

        // Uncheck the matching checkbox in the filter form
        if (self.filterForm && paramName && paramValue) {
          var checkbox = self.filterForm.querySelector(
            'input[type="checkbox"][name="' + paramName + '"][value="' + paramValue + '"]'
          );
          if (checkbox) checkbox.checked = false;
        }

        self._applyFilters();
      });
    },

    /* ------------------------------------------------------------------
       Browser back/forward button support
       ------------------------------------------------------------------ */
    _bindPopState: function () {
      var self = this;
      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.url) {
          self._fetchAndRender(e.state.url, false);
        }
      });
    },

    /* ------------------------------------------------------------------
       Build URL from current form state + sort, then fetch
       ------------------------------------------------------------------ */
    _applyFilters: function () {
      var params = new URLSearchParams();

      // Collect filter form values
      if (this.filterForm) {
        var formData = new FormData(this.filterForm);
        formData.forEach(function (value, key) {
          params.append(key, value);
        });
      }

      // Sort
      if (this.sortSelect && this.sortSelect.value) {
        params.set('sort_by', this.sortSelect.value);
      }

      var baseUrl = window.location.pathname;
      var newUrl  = baseUrl + '?' + params.toString();

      this._fetchAndRender(newUrl, true);
    },

    /* ------------------------------------------------------------------
       Fetch the new URL and swap the product grid
       ------------------------------------------------------------------ */
    _fetchAndRender: function (url, pushState) {
      var self = this;
      if (!this.gridInner) return;

      // Show loading state
      this.gridInner.classList.add('is-loading');
      this.gridInner.style.pointerEvents = 'none';

      fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Network error');
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-collection-grid]');
        var newActive = doc.querySelector('[data-active-filters]');
        var newCount  = doc.querySelector('[data-product-count]');

        if (newGrid) {
          self.gridInner.innerHTML = newGrid.innerHTML;
        }

        if (self.activeFiltersEl && newActive) {
          self.activeFiltersEl.innerHTML = newActive.innerHTML;
        }

        // Update product count text
        var countEl = document.querySelector('[data-product-count]');
        if (countEl && newCount) {
          countEl.textContent = newCount.textContent;
        }

        // Push state to history
        if (pushState && window.history && window.history.pushState) {
          window.history.pushState({ url: url }, '', url);
        }

        // Scroll to top of grid
        if (self.gridInner) {
          self.gridInner.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () {
        window.showToast && window.showToast('Could not load results. Please try again.', 'error');
      })
      .finally(function () {
        self.gridInner.classList.remove('is-loading');
        self.gridInner.style.pointerEvents = '';
      });
    }
  };

  /* ============================================================
     INIT
     ============================================================ */
  /* ============================================================
     MOBILE FILTER DRAWER
     ============================================================ */
  function initFilterDrawer() {
    var drawer  = document.querySelector('[data-filter-drawer]');
    var overlay = document.querySelector('[data-filter-drawer-overlay]');
    if (!drawer) return;

    function openDrawer()  { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

    document.querySelectorAll('[data-filter-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-filter-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
  }

  /* ============================================================
     FILTER GROUP ACCORDION
     ============================================================ */
  function initFilterGroups() {
    document.querySelectorAll('[data-filter-group-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var group = trigger.closest('[data-filter-group]');
        if (group) group.classList.toggle('is-open');
      });
    });
  }

  /* ============================================================
     GRID / LIST VIEW TOGGLE
     ============================================================ */
  function initViewToggle() {
    var grid    = document.querySelector('[data-collection-grid] .products-grid');
    var buttons = document.querySelectorAll('[data-view-toggle] [data-view]');
    if (!grid || !buttons.length) return;

    var saved = localStorage.getItem('autodrive_view') || 'grid';
    applyView(saved);

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var view = btn.getAttribute('data-view');
        localStorage.setItem('autodrive_view', view);
        applyView(view);
      });
    });

    function applyView(view) {
      grid.classList.toggle('is-list-view', view === 'list');
      buttons.forEach(function(b) {
        b.classList.toggle('is-active', b.getAttribute('data-view') === view);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    CollectionFilters.init();
    initFilterDrawer();
    initFilterGroups();
    initViewToggle();
  });

})();
